import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import {
  Avatar,
  Box,
  Button,
  Card,
  CardActions,
  CardHeader,
  CardContent,
  Divider,
  Typography,
  makeStyles,
} from '@material-ui/core'
import { useLocation } from 'react-router-dom'
// import { IMAGE_BASE_URL } from '../../../api/index'

const useStyles = makeStyles((theme) => ({
  root: {
    borderRadius: '20px',
  },
  avatar: {
    marginBottom: theme.spacing(2),
    height: 100,
    width: 100,
  },
  label: {
    width: '100%',
  },
  input: {
    display: 'none',
  },
  imageDesc: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: '10px',
    color: 'grey',
  },
}))

const ProfileImage = ({
  className, canEdit, userinfo, fileRef, lastPhoto, ...rest
}) => {
  const classes = useStyles()
  const location = useLocation()
  const url = userinfo?.photo?.url
  const [imgSrc, setImgSrc] = React.useState(lastPhoto)

  React.useEffect(() => {
    setImgSrc(lastPhoto)
  }, [url])

  const handleOnChange = () => {
    const file = fileRef.current?.files?.[0]
    console.log(file?.size, 'filedfhdjtfgj')
    // setPhotoSize(file?.size)
    if (!file) return
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onloadend = () => {
      setImgSrc(reader?.result)
    }
  }

  return (
    <>
      <Card
        className={clsx(classes.root, className)}
        {...rest}
      >
        <CardHeader
          title="عکس آزمون دهنده"
        />
        <Divider />
        <CardContent>
          <Box
            alignItems="center"
            display="flex"
            flexDirection="column"
          >
            <Avatar
              className={classes.avatar}
              src={location?.pathname?.includes('/app/customers/view/') ? url : imgSrc}
            />
            <Typography
              color="textPrimary"
              gutterBottom
              variant="h3"
            >
              {userinfo?.userName ?? ''}
            </Typography>
          </Box>
        </CardContent>
        {canEdit && (
        <>
          <Divider />
          <CardActions>
            <label htmlFor="contained-button-file" className={classes.label}>
              <input
                accept="image/jpeg, image/png"
                className={classes.input}
                id="contained-button-file"
                multiple
                type="file"
                ref={fileRef}
                onChange={handleOnChange}
              />
              <Button
                component="span"
                color="primary"
                fullWidth
                variant="text"
              >
                آپلود تصویر
              </Button>
            </label>
          </CardActions>
        </>
        )}
      </Card>
      <span className={classes.imageDesc}>حداکثر حجم فایل ۲ مگابایت</span>
    </>
  )
}

ProfileImage.propTypes = {
  canEdit: PropTypes.bool.isRequired,
  className: PropTypes.string,
  userinfo: PropTypes.object,
  fileRef: PropTypes.object,
}

export default ProfileImage
